import { render, staticRenderFns } from "./LikedLesson.vue?vue&type=template&id=0f4e608e&scoped=true&"
import script from "./LikedLesson.vue?vue&type=script&lang=js&"
export * from "./LikedLesson.vue?vue&type=script&lang=js&"
import style0 from "./LikedLesson.vue?vue&type=style&index=0&id=0f4e608e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4e608e",
  null
  
)

export default component.exports